var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCustom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_175492",
    "data-name": "Group 175492",
    transform: "translate(-494 -124)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9233",
    "data-name": "Ellipse 9233",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(494 124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-check",
    "data-name": "Icon feather-check",
    d: "M16.905,9l-7.5,7.5L6,13.089",
    transform: "translate(497.5 126.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCustom);
export default __webpack_public_path__ + "static/media/success_custom.6e778f037616a2cd9be7cbb2d6dc979a.svg";
export { ForwardRef as ReactComponent };